import React, { type FC } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ObjectSidebarControlProps } from '../src/ObjectSidebarControl.tsx';
import { OBJECT_SIDEBAR_CONTROL_METRIC } from '../src/perf.config.ts';

const ObjectSidebarControlLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarControl" */ '../src/ObjectSidebarControl.tsx'
			)
		).ObjectSidebarControl,
});

export const ObjectSidebarControl: FC<ObjectSidebarControlProps> = (props) => (
	<>
		<PageSegmentLoadStart metric={OBJECT_SIDEBAR_CONTROL_METRIC} />
		<ObjectSidebarControlLoader {...props} />
	</>
);
